export default () => ({
  bubble__container: {
    marginBottom: '1rem',
  },
});
